module.exports = __webpack_public_path__ + "img/product-shot_03_loading.a3aad861.jpg";